module.exports = __webpack_public_path__ + "img/ctrl-aggregate-stub-+i.0b741d05.svg";